import React, { useState } from 'react';
import './PhotoGallery.css';
import { Helmet } from 'react-helmet';
import BlurFade from './BlurFade';

const PhotoModal = ({ image, onClose }) => {
  return (
    <div className="photo-modal" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>&times;</button>
        <img src={image.src} alt={image.alt} />
        <div className="modal-info">
          <span className="category-tag">{image.category}</span>
          <p className="modal-description">{image.description}</p>
        </div>
      </div>
    </div>
  );
};

const PhotoGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Gallery images from public folder
  const galleryImages = [
    {
      id: 5,
      src: '/images/photo5.jpg',
      alt: 'A commemorative group photo featuring ADCI representatives with Swoyamjeet Panda, showcasing the strong bond within the ADCI community',
      category: 'Events',
      description: 'A commemorative group photo featuring ADCI representatives with Swoyamjeet Panda, showcasing the strong bond within the ADCI community'
    }
  ];

  return (
    <div className="photo-gallery-container">
      <Helmet>
        <title>Photo Gallery - ADCI</title>
        <meta name="description" content="Explore our photo gallery showcasing campus life, training sessions, and success stories at ADCI." />
        <meta name="keywords" content="ADCI gallery, defense training photos, campus life, student activities" />
      </Helmet>

      <BlurFade delay={0.2} inView>
        <div className="gallery-header">
          <h1>Photo Gallery</h1>
          <p>Capturing moments of excellence and achievement</p>
        </div>
      </BlurFade>

      <div className="gallery-grid">
        {galleryImages.map((image, index) => (
          <BlurFade 
            key={image.id}
            delay={0.2 + (index * 0.1)}
            inView
            direction="up"
          >
            <div className="gallery-item" onClick={() => setSelectedImage(image)}>
              <div className="image-container">
                <img src={image.src} alt={image.alt} />
                <div className="image-overlay">
                  <span className="category-tag">{image.category}</span>
                </div>
              </div>
              <div className="image-info">
                <p className="image-description">{image.description}</p>
              </div>
            </div>
          </BlurFade>
        ))}
      </div>

      {selectedImage && (
        <PhotoModal 
          image={selectedImage} 
          onClose={() => setSelectedImage(null)} 
        />
      )}
    </div>
  );
};

export default PhotoGallery; 